"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectService = void 0;
const tslib_1 = require("tslib");
const rxjs_1 = require("rxjs");
class ProjectService {
    constructor({ company, fetchTimeout, baseUrl, staticsUrl, }, token) {
        this.version = null;
        this.company = company;
        this.FETCH_TIMEOUT = fetchTimeout;
        this.BASE_URL = this.removeLastSlash(baseUrl);
        this.STATICS_URL = this.removeLastSlash(staticsUrl);
        this.TOKEN = token.toString();
    }
    removeLastSlash(string) {
        if (string.endsWith('/')) {
            return string.slice(0, -1);
        }
        return string;
    }
    getRequestHeaders() {
        return new Headers({
            Accept: 'application/json',
            Authorization: this.TOKEN,
            'Content-Type': 'application/json',
        });
    }
    fetchVersion() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const requestUrl = `${this.STATICS_URL}/api/brand/companies/${this.company}/version`;
            const request = yield fetch(requestUrl, { method: 'GET' });
            return request.json();
        });
    }
    getVersion() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.version)
                return this.version;
            const response = yield this.fetchVersion();
            this.version = response;
            return response;
        });
    }
    fetchResourceFromApi(resource) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const requestUrl = `${this.BASE_URL}/brand/companies/${this.company}/${resource}`;
            const request = yield fetch(requestUrl, {
                method: 'GET',
                headers: this.getRequestHeaders(),
            });
            return request.json();
        });
    }
    fetchResourceFromVersion(resource) {
        var _a;
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const version = yield this.getVersion();
            const endpoint = `api/brand/companies/${this.company}/${resource}`;
            const endpointUrl = (_a = version[endpoint]) === null || _a === void 0 ? void 0 : _a.key;
            if (!endpointUrl) {
                return yield this.fetchResourceFromApi(resource);
            }
            const requestUrl = `${this.STATICS_URL}/${endpointUrl}`;
            const request = yield fetch(requestUrl, { method: 'GET' });
            return request.json();
        });
    }
    fetchCampaignsData() {
        return this.fetchResourceFromVersion('campaigns?consume');
    }
    fetchFormatsData() {
        return this.fetchResourceFromVersion('formats?consume');
    }
    fetchFoldersData() {
        return this.fetchResourceFromVersion('campaigns-folders/root/children');
    }
    fetchTemplateData(campaignId) {
        return this.fetchResourceFromVersion(`campaigns/${campaignId}/templates?consume`);
    }
    buildTemplateData(formatsData, campaignsData, foldersData) {
        /**
         * Copied from the Editor
         * Needs refactoring
         */
        if (campaignsData && formatsData) {
            return campaignsData
                .map((campaign) => {
                var _a;
                const folders = foldersData.length ? foldersData : [];
                const folder = folders.find((folder) => folder.id === campaign.folder);
                const campaignFormats = formatsData.filter((format) => format.campaign === campaign.id);
                return {
                    id: campaign.id,
                    name: campaign.name,
                    data: campaignFormats,
                    folderId: (_a = folder === null || folder === void 0 ? void 0 : folder.id) !== null && _a !== void 0 ? _a : 0,
                    folderName: String(folder === null || folder === void 0 ? void 0 : folder.name),
                };
            })
                .sort((a, b) => (a.folderId > b.folderId ? 1 : -1));
        }
        return [];
    }
    fetchFormats() {
        return (0, rxjs_1.forkJoin)([
            (0, rxjs_1.from)(this.fetchFormatsData()),
            (0, rxjs_1.from)(this.fetchCampaignsData()),
            (0, rxjs_1.from)(this.fetchFoldersData()),
        ]).pipe((0, rxjs_1.timeout)(this.FETCH_TIMEOUT), (0, rxjs_1.map)(([formatsData, campaignsData, foldersData]) => this.buildTemplateData(formatsData, campaignsData, foldersData)), (0, rxjs_1.catchError)((err) => {
            console.error('FetchFormats failed', err);
            return (0, rxjs_1.of)(null);
        }));
    }
    fetchCampaigns() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.getVersion();
            return yield new Promise((resolve) => {
                const formats$ = this.fetchFormats();
                formats$.subscribe(resolve);
            });
        });
    }
    fetchTemplates(campaignId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return yield this.fetchTemplateData(campaignId);
        });
    }
}
exports.ProjectService = ProjectService;
//# sourceMappingURL=project.service.js.map